import { Anchor } from "@newsela/angelou";

import ErrorMessage from "@/errors/ErrorMessage";

const InsightsErrorPage = () => (
  <ErrorMessage headline="Oh no, something went wrong.">
    <p>
      Please reload the page and try again. If you still run into issues,
      please&nbsp;
      <Anchor
        isInline
        __cssFor={{
          root: {},
        }}
        href="https://newsela.com/about/contact/"
      >
        contact us
      </Anchor>
      .
    </p>
  </ErrorMessage>
);

export default InsightsErrorPage;
